import { api } from "./base-config";
import {
  HelenaDocumentType,
  HelenaPatientStatusEnum,
  HelenaPrescriptionType,
  HelenaSessionKey
} from "model/helena.model";
import { Patient } from "model/patient.model";
import { HelenaRegistration } from "model/helena-registration.model";

export const createSession = async (
  userId: number
): Promise<HelenaSessionKey> => {
  return api
    .post(`/resources/secured/rs/caregivers/${userId}/helena/session`)
    .then(response => response.data);
};

export const uploadPrescriptions = async (
  patientId: number,
  userId: number,
  helenaPrescriptions: Array<HelenaPrescriptionType>,
  sessionKey: HelenaSessionKey,
  helenaPatientId: string
): Promise<void> => {
  return api
    .post(
      `/resources/secured/rs/caregivers/${userId}/helena/${patientId}/prescriptions`,
      {
        sessionKey: sessionKey,
        patientId: helenaPatientId,
        prescriptions: helenaPrescriptions
      }
    )
    .then(response => Promise.resolve());
};

export const uploadAttestation = async (
  patientId: number,
  userId: number,
  sessionKey: HelenaSessionKey,
  helenaPatientId: string,
  helenaDocument: HelenaDocumentType
): Promise<void> => {
  return api
    .post(
      `/resources/secured/rs/caregivers/${userId}/helena/${patientId}/document`,
      {
        sessionKey: sessionKey,
        patientId: helenaPatientId,
        helenaDocument: helenaDocument
      }
    )
    .then(response => Promise.resolve());
};

export const loadPatientStatus = async (
  userId: number,
  sessionKey: HelenaSessionKey,
  helenaPatientId: string
): Promise<HelenaPatientStatusEnum> => {
  return api
    .post(`/resources/secured/rs/caregivers/${userId}/helena/status`, {
      sessionKey: sessionKey,
      patientId: helenaPatientId
    })
    .then(response => response.data.status);
};

export const loadPatientId = async (
  userId: number,
  sessionKey: HelenaSessionKey,
  inss: string
): Promise<string> => {
  return api
    .post(`/resources/secured/rs/caregivers/${userId}/helena/patientid`, {
      sessionKey: sessionKey,
      inss: inss
    })
    .then(response => response.data.patientId);
};

export const retrieveRegistrationLink = async (
  userId: number,
  sessionKey: HelenaSessionKey,
  patient: Patient
): Promise<string> => {
  return api
    .post(
      `/resources/secured/rs/caregivers/${userId}/helena/registrationlink`,
      {
        sessionKey: sessionKey,
        inss: patient.inss,
        firstName: patient.firstName,
        lastName: patient.lastName,
        email: patient.address && patient.address.email,
        cellPhoneNumber: patient.address && patient.address.cellPhoneNumber,
        language: patient.language ?? "nl"
      }
    )
    .then(response => response.data.registrationLink);
};

export const retrieveRegistrationFinished = async (
  userId: number,
  sessionKey: HelenaSessionKey,
  inss: string
): Promise<HelenaRegistration> => {
  return api
    .post(
      `/resources/secured/rs/caregivers/${userId}/helena/registrationfinished`,
      {
        sessionKey: sessionKey,
        inss: inss
      }
    )
    .then(response => {
      return response.data;
    });
};
